import { Injectable } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

import { HubConfigSegmentationDrawerComponent } from '@main-client/src/app/hub-configuration/hub-config-segmentations/hub-config-segmentation-drawer/hub-config-segmentation-drawer.component';

import { Group } from '@libs/src/models/group.model';

@Injectable()
export class HubConfigSegmentationDrawerService {
  constructor(private readonly drawerService: NzDrawerService) {}

  openDrawer(group: Group, segmentationKey: string) {
    const description = group.field_descriptions.find(
      (field) => field.name === segmentationKey,
    )?.description;
    return this.drawerService.create({
      nzBodyStyle: { padding: 0 },
      nzContent: HubConfigSegmentationDrawerComponent,
      nzData: { data: { group, segmentationKey } },
      nzTitle: description?.length
        ? $localize`:@@hubConfigSegmentationDialog.editTitle: Edit description`
        : $localize`:@@hubConfigSegmentationDialog.addTitle: Add description`,
      nzWidth: '400px',
    });
  }
}
